import React from "react";

export const GameContext = React.createContext({});

const defaultBox = Array.from({ length: 9 }).reduce(
  (acc, _, index) => ({ ...acc, [index]: null }),
  {}
);

class GameContextProvider extends React.PureComponent {
  state = {
    turn: 1,
    score: { firstPlayer: 0, secondPlayer: 0 },
    board: { ...defaultBox },
    isFinish: false,
    winner: null,
    winLines: null,
    pendingScore: null,
    resultReady: false,
  };

  addTurn = () => {
    this.setState((state) => ({ turn: state.turn + 1 }));
  };

  finishRound = ({ score, winner, winLines }) => {
    this.setState({
      isFinish: true,
      pendingScore: score,
      winner,
      winLines,
      resultReady: false,
    });
  };

  revealResult = () => {
    this.setState((state) => ({
      score: state.pendingScore || state.score,
      pendingScore: null,
      resultReady: true,
    }));
  };

  updateBoard = (board) => {
    this.setState({ board });
  };

  resetGame = (score) => {
    this.setState({
      turn: 1,
      score,
      board: { ...defaultBox },
      isFinish: false,
      winner: null,
      winLines: null,
      pendingScore: null,
      resultReady: false,
    });
  };

  render() {
    return (
      <GameContext.Provider
        value={{
          ...this.state,
          addTurn: this.addTurn,
          updateBoard: this.updateBoard,
          resetGame: this.resetGame,
          finishRound: this.finishRound,
          revealResult: this.revealResult,
        }}
      >
        {this.props.children}
      </GameContext.Provider>
    );
  }
}

export default GameContextProvider;
